(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rotoq-cook-with"] && !Shopify.designMode) return;
  try {
    // A product card renders one copy of this per card, and collection filtering
  // swaps whole cards in, so init is idempotent and watches for late arrivals
  // rather than running once at parse time.
  (() => {
    const init = (root) => {
      if (root.dataset.cookReady) return;
      root.dataset.cookReady = '1';

      const rail = root.querySelector('[data-cook-rail]');
      const control = root.querySelector('[data-cook-toggle], .rotoq-cook__more');
      if (!rail || !control) return;

      // Only worth a control if the rail is actually wider than its box.
      const sync = () => {
        control.hidden = rail.scrollWidth <= rail.clientWidth + 1;
      };

      const dialog = root.querySelector('[data-cook-dialog]');
      if (dialog) {
        // A phone gets the modal behind View more; a desktop product page has
        // the width to just show the panel, so it stands open in the flow and
        // the rail steps aside for it. `show()` is the same dialog without the
        // top layer, so one element serves both.
        const desktop = window.matchMedia('(min-width: 750px)');
        const wantsPanel = root.dataset.inlinePanel === 'true';
        const inline = () => wantsPanel && desktop.matches;

        // Which of the two it was opened as. A modal lives in the top layer
        // with a backdrop over the page, so one left open across a resize to
        // desktop covers the whole product page — the mode has to be switched,
        // not just left alone because the dialog happens to be open.
        let isModal = false;

        const open = () => {
          if (dialog.open) return;
          isModal = !inline();
          if (isModal) dialog.showModal();
          else dialog.show();
        };

        const close = () => {
          if (!dialog.open) return;
          dialog.close();
          isModal = false;
        };

        const applyBreakpoint = () => {
          if (!wantsPanel) return;

          if (desktop.matches) {
            if (isModal) close();
            open();
          } else if (!isModal) {
            // Inline on a phone would just be an unclosable block of text.
            close();
          }
        };

        applyBreakpoint();
        desktop.addEventListener('change', applyBreakpoint);

        control.addEventListener('click', (event) => {
          // Inside a product card the whole tile is a link; without this the
          // click opens the dialog and navigates away from underneath it.
          event.preventDefault();
          event.stopPropagation();

          if (dialog.open) close();
          else open();
          control.setAttribute('aria-expanded', String(dialog.open));
        });

        dialog.querySelector('[data-cook-close]')?.addEventListener('click', () => {
          close();
          control.setAttribute('aria-expanded', 'false');
        });

        // Clicking the backdrop means clicking the dialog itself: its own box
        // is the inner element, so anything outside that is the backdrop.
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) close();
        });

        // Escape closes a modal without going through close(), so the flag has
        // to come back into line or the next resize reads it as still modal.
        dialog.addEventListener('close', () => {
          isModal = false;
          control.setAttribute('aria-expanded', 'false');
        });
      }

      sync();
      new ResizeObserver(sync).observe(rail);
    };

    const scan = (scope) => scope.querySelectorAll?.('.rotoq-cook').forEach(init);

    scan(document);
    document.addEventListener('DOMContentLoaded', () => scan(document));
    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.classList?.contains('rotoq-cook')) init(node);
          scan(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
